import {
    emptyDatiqMenu,
    emptyDatiqMenuItem,
} from '@dat/datiq-components-pkg/menu';
import {
    IDatiqCellMenu,
    IDatiqCellMenuItem,
} from './datiq-cell-menu.interface';

export const emptyDatiqCellMenuItem: IDatiqCellMenuItem = {
    ...emptyDatiqMenuItem,
    data: {
        name: 'No action fired',
    },
};

export const emptyDatiqCellMenu: IDatiqCellMenu = {
    ...emptyDatiqMenu,
    items: [],
};
